import { createStore, applyMiddleware, compose } from 'redux';
import Flatted from 'flatted';
import thunk from 'redux-thunk';
import { localForage } from './utils/misc';

import { persistStore, persistReducer, createTransform } from 'redux-persist';
import rootReducer from './_reducers/index';

export const transformCircular = createTransform(
  (inboundState, key) => Flatted.stringify(inboundState),
  (outboundState, key) => Flatted.parse(outboundState)
);

const persistedReducer = persistReducer(
  {
    storage: localForage,
    key: 'cms:',
    transforms: [transformCircular]
    // blacklist: ['projectsState']
  },
  rootReducer
);

export default function configureStore() {
  return createStore(
    persistedReducer,
    compose(
      applyMiddleware(thunk),
      // autoRehydrate(),
      typeof window !== 'undefined' && window.devToolsExtension
        ? window.devToolsExtension()
        : f => f
    )
  );
}

export const store = configureStore();
export const persistor = persistStore(store);
